module.exports = __webpack_public_path__ + "img/feedback.b91726f9.svg";